






























































































































































































import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {

  }
})
export default class UserContract extends Vue {

  private docScorll(divNum: number) {
    const el: any = document.getElementById('h' + divNum);
    window.scrollBy(0, el.getBoundingClientRect().top)
  }

}
